import { isAxiosError } from "axios"

import type { BatteryPresentationReadinessDto } from "./dto/battery-presentation.dto"

type NotReadyReason = Extract<
  BatteryPresentationReadinessDto,
  { ready: false }
>[`reason`]

const REASONS: readonly NotReadyReason[] = [`not_calculated`, `out_of_date`]

/**
 * The publish conflict the gateway raises when pricing is not current. Its
 * `error` carries the same reason the readiness read reports, so a publish
 * that loses a race can explain itself instead of failing generically.
 */
export const publishBlockedReason = (error: unknown): NotReadyReason | null => {
  if (!isAxiosError(error) || error.response?.status !== 409) {
    return null
  }

  const reason = (error.response.data as { error?: unknown } | undefined)?.error

  return REASONS.find((candidate) => candidate === reason) ?? null
}
